import { gql, useQuery } from '@apollo/client';
import React, { useState } from 'react'
import { AppInputFieldSelect } from '../../../../../widget/styledComponents/input_field.style';
import { Spinner } from 'evergreen-ui';




export const FETCH_BANKS = gql`
query Payment_getBanks{
  payment_getBanks {
    name
    code
  }
}
`;

const ListBank = ({ onSelect }) => {
const { loading, error, data }  = useQuery(FETCH_BANKS);
const [selectedOption, setSelectedOption] = useState('');

if (loading) return <Spinner/>;
if (error) return <p>Error: {error.message}</p>;
const options = data.payment_getBanks;

const handleSelect = (event) => {
  const selectedValue = event.target.value;
  setSelectedOption(selectedValue);
  console.log("Selected value:", selectedValue);
  onSelect(selectedValue)
};
  return (
    <div>
        <AppInputFieldSelect
            className="browser-default" required
            value={selectedOption} onChange={handleSelect}
            >
            <option value="" disabled selected>Choose your option</option>
            {options.map((option) => (
            <option key={option.code}  value={option.code}
            >
                {option.name}
            </option >
            ))}
        </AppInputFieldSelect>
        
    </div>
  )
}

export default ListBank;